// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-2y1NE";
var _4 = "content-2YnqD";
var _5 = "icon-23vil";
var _6 = "link-2ep7t";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "content", _5 as "icon", _6 as "link" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "content": _4, "icon": _5, "link": _6 }
